import { render, staticRenderFns } from "./RecuperacionContrasena.vue?vue&type=template&id=58396902&scoped=true"
import script from "./RecuperacionContrasena.vue?vue&type=script&lang=ts"
export * from "./RecuperacionContrasena.vue?vue&type=script&lang=ts"
import style0 from "./RecuperacionContrasena.vue?vue&type=style&index=0&id=58396902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58396902",
  null
  
)

export default component.exports